/* ta-base.js — global TradingAces JS API: cart (add, drawer, steppers), toast, money, checked-time, header height, mega menu. Vanilla, defensive. */
(function () {
  'use strict';
  var TA = window.TA = window.TA || {};
  var routes = TA.routes || {};
  var R = {
    root: routes.root || '/',
    cart: routes.cart || '/cart',
    cartAdd: routes.cartAdd || '/cart/add.js',
    cartChange: routes.cartChange || '/cart/change.js',
    cartJs: routes.cartJs || '/cart.js'
  };
  var doc = document;
  var root = doc.documentElement;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  /* ---------- reduced motion (live) ---------- */
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduced = !!(mq && mq.matches);
  if (mq) {
    var onMq = function (e) { reduced = e.matches; };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  }
  Object.defineProperty(TA, 'reducedMotion', { get: function () { return reduced; }, configurable: true });

  /* ---------- money ---------- */
  function withDelimiters(number, precision, thousands, decimal) {
    var n = (number / 100).toFixed(precision);
    var parts = n.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? dollars + decimal + parts[1] : dollars;
  }
  TA.formatMoney = function (cents) {
    var fmt = TA.moneyFormat || '${{amount}}';
    cents = Number(cents) || 0;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      switch (name) {
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(cents, 0, ' ', '.');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        default: return withDelimiters(cents, 2, ',', '.');
      }
    });
  };

  /* ---------- toast ---------- */
  var toastTimer;
  TA.toast = function (msg) {
    var el = $('[data-ta-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2400);
  };

  /* ---------- cart ---------- */
  function setCounts(n) {
    TA.cartCount = n;
    $$('[data-ta-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function jsonFetch(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Accept': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data && (data.description || data.message) || 'Request failed');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }
  function sectionHtml(id) {
    var sep = R.root.indexOf('?') === -1 ? '?' : '&';
    return fetch(R.root + sep + 'sections=' + encodeURIComponent(id), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j[id];
        if (!html) return null;
        var d = new DOMParser().parseFromString(html, 'text/html');
        var wrap = d.querySelector('.shopify-section');
        return wrap ? wrap.innerHTML : d.body.innerHTML;
      });
  }
  function rerender() {
    var tasks = [];
    var body = $('[data-ta-drawer-body]');
    if (body) {
      tasks.push(sectionHtml('ta-cart-drawer-content').then(function (html) {
        if (html == null) return;
        var active = doc.activeElement && doc.activeElement.closest && doc.activeElement.closest('[data-ta-line]');
        var line = active ? active.getAttribute('data-ta-line') : null;
        body.innerHTML = html;
        if (line) { var inp = $('[data-ta-line="' + line + '"] [data-ta-qty-input]', body); if (inp) inp.focus(); }
      }));
    }
    var page = $('[data-ta-cartpage]');
    if (page) {
      var sid = page.getAttribute('data-section-id');
      tasks.push(sectionHtml(sid).then(function (html) {
        if (html == null) return;
        var d = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
        var fresh = d.querySelector('[data-ta-cartpage]');
        if (!fresh) return;
        var active = doc.activeElement && doc.activeElement.closest && doc.activeElement.closest('[data-ta-line]');
        var line = active ? active.getAttribute('data-ta-line') : null;
        page.innerHTML = fresh.innerHTML;
        if (line) { var inp = $('[data-ta-line="' + line + '"] [data-ta-qty-input]', page); if (inp) inp.focus(); }
      }));
    }
    return Promise.all(tasks).catch(function () {});
  }
  function announce(cart) {
    setCounts(cart.item_count);
    doc.dispatchEvent(new CustomEvent('ta:cart:updated', { detail: cart }));
  }
  TA.refreshCart = function () {
    return jsonFetch(R.cartJs, { cache: 'no-store' }).then(function (cart) {
      return rerender().then(function () { announce(cart); return cart; });
    });
  };
  TA.addToCart = function (variantId, qty, opts) {
    opts = opts || {};
    qty = parseInt(qty, 10) || 1;
    var props = opts.properties;
    var item = { id: Number(variantId), quantity: qty };
    if (props) item.properties = props;
    return jsonFetch(R.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function () {
      return TA.refreshCart();
    }).then(function (cart) {
      if (opts.toast !== false) TA.toast('Added to cart');
      if (opts.openCart) TA.openCart();
      return cart;
    }).catch(function (err) {
      TA.toast(err && err.message ? err.message : 'Could not add to cart');
      throw err;
    });
  };
  TA.changeLine = function (line, quantity) {
    var lines = $$('.ta-lines');
    lines.forEach(function (l) { l.classList.add('is-busy'); });
    return jsonFetch(R.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(function (cart) {
      return rerender().then(function () { announce(cart); return cart; });
    }).catch(function (err) {
      TA.toast(err && err.message ? err.message : 'Could not update cart');
      return TA.refreshCart();
    });
  };

  /* drawer */
  function drawer() { return $('[data-ta-drawer]'); }
  TA.openCart = function () {
    var d = drawer();
    if (!d) { if (R.cart && location.pathname.replace(/\/$/, '') !== R.cart.replace(/\/$/, '')) location.href = R.cart; return; }
    if (!d.open) {
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      root.classList.add('ta-lock');
    }
  };
  TA.closeCart = function () {
    var d = drawer();
    if (d && d.open) { if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); }
    root.classList.remove('ta-lock');
  };
  doc.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-ta-drawer]')) root.classList.remove('ta-lock');
  }, true);

  /* qty debounce per line */
  var qtyTimers = {};
  function queueQty(line, qty) {
    clearTimeout(qtyTimers[line]);
    qtyTimers[line] = setTimeout(function () { TA.changeLine(line, qty); }, 350);
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var addBtn = t.closest('[data-ta-add]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.disabled || addBtn.classList.contains('is-busy')) return;
      var id = addBtn.getAttribute('data-ta-add');
      var qty = addBtn.getAttribute('data-qty') || 1;
      var open = addBtn.getAttribute('data-open-cart') === 'true';
      var original = addBtn.getAttribute('data-ta-label') || addBtn.textContent;
      addBtn.setAttribute('data-ta-label', original);
      addBtn.classList.add('is-busy');
      TA.addToCart(id, qty, { openCart: open }).then(function () {
        addBtn.classList.add('is-added');
        addBtn.textContent = 'Added';
        setTimeout(function () { addBtn.classList.remove('is-added'); addBtn.textContent = original; }, 1600);
      }).catch(function () {}).then(function () { addBtn.classList.remove('is-busy'); });
      return;
    }

    var opener = t.closest('[data-ta-cart-open]');
    if (opener && drawer() && !(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) {
      e.preventDefault();
      TA.openCart();
      return;
    }

    if (t.closest('[data-ta-drawer-close]')) { TA.closeCart(); return; }

    var dlg = drawer();
    if (dlg && t === dlg) { TA.closeCart(); return; }

    var step = t.closest('[data-ta-qty-step]');
    if (step) {
      var li = step.closest('[data-ta-line]');
      var input = li && $('[data-ta-qty-input]', li);
      if (!input) return;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.getAttribute('data-ta-qty-step')));
      var max = parseInt(input.getAttribute('max'), 10);
      if (max && next > max) { TA.toast('Only ' + max + ' available'); next = max; }
      input.value = next;
      queueQty(li.getAttribute('data-ta-line'), next);
      return;
    }

    var rm = t.closest('[data-ta-remove]');
    if (rm) {
      var row = rm.closest('[data-ta-line]');
      if (!row) return;
      e.preventDefault();
      TA.changeLine(row.getAttribute('data-ta-line'), 0);
    }
  });

  doc.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-ta-qty-input]')) return;
    var li = input.closest('[data-ta-line]');
    if (!li) return;
    var v = Math.max(0, parseInt(input.value, 10) || 0);
    var max = parseInt(input.getAttribute('max'), 10);
    if (max && v > max) { TA.toast('Only ' + max + ' available'); v = max; }
    input.value = v;
    queueQty(li.getAttribute('data-ta-line'), v);
  });

  /* ---------- mega menu ---------- */
  function menuParts() {
    return { btn: $('[data-ta-menu-btn]'), menu: $('[data-ta-menu]'), scrim: $('[data-ta-menu-scrim]') };
  }
  function setMenu(open, returnFocus) {
    var p = menuParts();
    if (!p.btn || !p.menu) return;
    p.menu.hidden = !open;
    if (p.scrim) p.scrim.hidden = !open;
    p.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open && returnFocus) p.btn.focus();
  }
  function menuOpen() { var p = menuParts(); return !!(p.btn && p.btn.getAttribute('aria-expanded') === 'true'); }
  doc.addEventListener('click', function (e) {
    var p = menuParts();
    if (!p.btn || !e.target.closest) return;
    if (e.target.closest('[data-ta-menu-btn]')) { setMenu(!menuOpen(), false); return; }
    if (menuOpen() && !e.target.closest('[data-ta-menu]')) setMenu(false, false);
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menuOpen()) { setMenu(false, true); }
  });
  doc.addEventListener('focusin', function (e) {
    if (menuOpen() && e.target.closest && !e.target.closest('[data-ta-header]')) setMenu(false, false);
  });

  /* ---------- header height ---------- */
  function syncHeader() {
    var h = $('[data-ta-header]');
    if (!h) return;
    root.style.setProperty('--ta-header-h', h.offsetHeight + 'px');
  }
  function watchHeader() {
    var h = $('[data-ta-header]');
    if (!h) return;
    syncHeader();
    if (window.ResizeObserver) new ResizeObserver(syncHeader).observe(h);
    else window.addEventListener('resize', syncHeader);
  }

  /* ---------- "Checked …" formatter (America/Chicago) ---------- */
  var TZ = 'America/Chicago';
  var fmtDay, fmtTime, fmtMD;
  try {
    fmtDay = new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' });
    fmtTime = new Intl.DateTimeFormat('en-US', { timeZone: TZ, hour: 'numeric', minute: '2-digit', hour12: true });
    fmtMD = new Intl.DateTimeFormat('en-US', { timeZone: TZ, month: 'short', day: 'numeric' });
  } catch (err) { fmtDay = fmtTime = fmtMD = null; }
  function dayKey(ms) { return fmtDay.format(new Date(ms)); }
  function checkedText(ts) {
    var ms = ts * 1000, now = Date.now();
    var key = dayKey(ms);
    var time = fmtTime.format(new Date(ms)) + ' CT';
    if (key === dayKey(now)) return 'Checked today, ' + time;
    if (key === dayKey(now - 86400000)) return 'Checked yesterday, ' + time;
    return 'Checked ' + fmtMD.format(new Date(ms)) + ', ' + time;
  }
  TA.refreshChecked = function (ctx, all) {
    if (!fmtDay) return;
    $$(all ? '[data-ta-checked]' : '[data-ta-checked]:not([data-ta-checked-done])', ctx).forEach(function (el) {
      var ts = parseInt(el.getAttribute('data-ta-checked'), 10) || 0;
      if (!ts) { el.hidden = true; el.setAttribute('data-ta-checked-done', ''); return; }
      el.hidden = false;
      var target = $('[data-ta-checked-text]', el) || el;
      var text = checkedText(ts);
      if (target.textContent !== text) target.textContent = text;
      var stale = parseFloat(el.getAttribute('data-stale-hours')) || 0;
      el.classList.toggle('is-stale', !!stale && (Date.now() / 1000 - ts) > stale * 3600);
      el.setAttribute('data-ta-checked-done', '');
    });
  };

  /* ---------- init ---------- */
  function init() {
    if (typeof TA.cartCount === 'number') setCounts(TA.cartCount);
    watchHeader();
    TA.refreshChecked(doc, true);
    setInterval(function () { TA.refreshChecked(doc, true); }, 300000);
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; TA.refreshChecked(doc, false); }, 50);
      }).observe(doc.body, { childList: true, subtree: true });
    }
    doc.addEventListener('shopify:section:load', function () { watchHeader(); TA.refreshChecked(doc, true); });
    doc.addEventListener('ta:checked:refresh', function () { TA.refreshChecked(doc, true); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) TA.refreshCart().catch(function () {}); });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
